export default "__VITE_ASSET__O_VXjhPi__"